import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=278c512f&scoped=true&"
import script from "./footer.component.ts?vue&type=script&lang=ts&"
export * from "./footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./footer.scss?vue&type=style&index=0&id=278c512f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c512f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278c512f')) {
      api.createRecord('278c512f', component.options)
    } else {
      api.reload('278c512f', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=278c512f&scoped=true&", function () {
      api.rerender('278c512f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer/footer.vue"
export default component.exports